<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات حقوق</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام و نام خانوادگی</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> سال </label>
          <select [(ngModel)]="Filter_year" (change)="ReadData_Salary()" class="custom-select">
            <option value="1403">سال 1403</option>
            <option value="1404">سال 1404</option>
            <option value="1405">سال 1405</option>
            <option value="1406">سال 1406</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> ماه </label>
          <select [(ngModel)]="Filter_month" (change)="ReadData_Salary()" class="custom-select">
            <option value="1">فرودین</option>
            <option value="2">اردبیهشت</option>
            <option value="3">خرداد</option>
            <option value="4">تیر</option>
            <option value="5">مرداد</option>
            <option value="6">شهریور</option>
            <option value="7">مهر</option>
            <option value="8">آبان</option>
            <option value="9">آذر</option>
            <option value="10">دی</option>
            <option value="11">بهمن</option>
            <option value="12">اسفند</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Salary()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>

              <th>نام و نام خانوادگی</th>
              <th>حقوق ثابت</th>
              <th>ایاب و ذهاب</th>
              <th>اضافه کاری</th>
              <th>حق ماموریت</th>
              <th>دریافتی کل</th>
              
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Salary
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Salary|filter:Filter_title:'fullname').length
                      }
            ">

              <tr>
                <td rowspan="3">{{DataList_Salary.indexOf(item)+1}}</td>
                
                <td rowspan="3">{{item.fullname}}</td>

                <td>{{item.salary|number}}</td>
                <td>{{item.ayabZohab|number}} </td>
                <td>{{item.ezakekar|number}} </td>
                <td>{{item.mission|number}} </td>

                <td rowspan="3">{{item.salary2|number}} </td>
                <td rowspan="3">
                  <button (click)="Set_Form_Salary_View_Add2(item.personId)" type="button"
                    class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> جزئیات
                  </button>
                  <button (click)="OpenSalaryPdf(item.personId)" type="button" class="btn btn-danger"
                    [disabled]="PdfOpeningPersonId !== null" style="margin-left: 5px;">
                    <i class="fa fa-file-pdf-o"></i>
                    {{PdfOpeningPersonId === item.personId ? '...' : 'PDF'}}
                  </button>
                </td>
              </tr>
              <tr>

                <th>ساعت اضافه کاری</th>
                <td>{{item.ezakekarCount}} </td>
                
                <th>تعداد ماموریت</th>
                <td>{{item.missionCount}} </td>
              </tr>

              <tr>
                <th>مبلغ بیمه سهم کارگر</th>
                <td>{{item.bimehKargar|number}} </td>

                <th>مبلغ مالیات</th>
                <td>{{item.maliatPay|number}} </td>
              </tr>

            </ng-container>


          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<app-SalaryFish *ngIf="Selected_Salary_Record_Switcher=='Fish'" 
  (outter_Salary)="Set_List_Salary_View()"
  [innerYear]="Selected_Salary_Year" [innerMonth]="Selected_Salary_Month" [innerPersonId]="Selected_Salary_PersonId">

</app-SalaryFish>
